import { TrainingStep } from "../../components/common/TrainingGuide";

const crmSteps: TrainingStep[] = [
  {
    title: "CRM — Lead Intelligence",
    description:
      "The CRM tracks every potential customer from first contact to closed deal. Leads are scored by AI, color-coded by importance, and organised in a visual pipeline.",
    tip: "Every WhatsApp conversation that shows purchase intent automatically creates a lead here.",
  },
  {
    title: "Pipeline Stages",
    description:
      "Leads move through six stages: New → Contacted → Qualified → Proposal → Negotiation → Closed. Drag a lead card to move it, or open the lead and change the status dropdown.",
    tip: "Keep leads moving. A lead that sits in 'Contacted' for more than 3 days needs a follow-up call.",
  },
  {
    title: "Creating a New Lead",
    description:
      "Click '+ New Lead' in the top-right (or press N). Fill in name, phone, source, category (Retail / Wholesale / Distributor), and estimated deal value. The AI score is calculated automatically.",
    tip: "Always enter the phone number with country code (+971...) so WhatsApp integration works correctly.",
  },
  {
    title: "Lead Detail & Notes",
    description:
      "Click any lead to open its detail drawer. You'll see contact info, activity log, AI summary, and the notes field. Use notes to record what was discussed in each interaction.",
    tip: "The AI text helper (✨) in the notes field can polish rough notes into professional summaries.",
  },
  {
    title: "Phone Integration",
    description:
      "The Phone tab (📱) embeds a phone launcher powered by scrcpy. Click a lead's phone number to dial directly. The call is automatically logged against the lead with duration and outcome.",
    tip: "After a call, add a note while it's fresh — even just two lines about what was agreed.",
  },
  {
    title: "Keyboard Shortcuts",
    description:
      "CRM has its own shortcuts: N = new lead, F = focus search, 1–6 = filter by pipeline stage, Enter = open selected lead, Ctrl+Enter = save form, Esc = close modal.",
    tip: "Press the ⌨️ button in the header to see a full shortcut reference card.",
  },
  {
    title: "Bulk Actions & Broadcast",
    description:
      "Select multiple leads using the checkboxes on each card. Then use 'Send to Group' to compose one WhatsApp message sent to all selected leads. Great for follow-up campaigns.",
    tip: "Use the AI text helper when composing broadcast messages — it optimises for UAE business tone.",
  },
];

export default crmSteps;
